module.exports = __webpack_public_path__ + "img/Weapon_40.ee020174.png";